/** Practice Phrases stays in the codebase; set to `true` to show it again in overflow menus. */
export const SHOW_PRACTICE_PHRASES_IN_MENU = false;

/** Print / Download PDF action in card detail menu. */
export const SHOW_PRINT_CARD = false;

/** Share Collection action in the Collections page menu. */
export const SHOW_SHARE_COLLECTION = false;

/** Bulk "Enrich with AI" button shown when cards are selected in the library. */
export const SHOW_BULK_ENRICH = false;
